module.exports = __webpack_public_path__ + "static/ces-cd556f222fc65ad821bd5dd8dbb43a70.jpg";